import React from 'react';
import PropTypes from 'prop-types';
import { COOKIE_CATEGORY } from 'common/constants/cookieManagement';
import GuestBrandedSwitch from './GuestBranded/components/GuestBrandedSwitch';
import GuestBrandedAccordion from './GuestBranded/components/GuestBrandedAccordion';
import GuestBrandedButton from './GuestBranded/components/GuestBrandedButton';
import { CookieBannerConsentSettingsStyles } from './CookieBanner.styles';

const SettingSection = ({ heading, description, type, value, onChange, styles }) => (
    <>
        <div style={styles.settingSection}>
            <div>
                <div style={styles.settingHeading}>{heading}</div>
                <div style={styles.settingDescription}>{description}</div>
            </div>
            <div style={styles.settingSwitch}>
                {type === COOKIE_CATEGORY.NECESSARY ? (
                    <div style={styles.alwaysOn}>Always on</div>
                ) : (
                    <GuestBrandedSwitch id={type} value={value} onUpdate={onChange} />
                )}
            </div>
        </div>
        <div style={styles.divider} />
    </>
);

SettingSection.propTypes = {
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.object.isRequired,
};

const CookieBannerConsentSettings = ({
    isConsentSettingsOpen,
    onClickOpenConsentSettings,
    bannerText,
    consentSettings,
    updateConsentSetting,
    onConfirmSelection,
}) => {
    const styles = CookieBannerConsentSettingsStyles;

    return (
        <div style={styles.container}>
            <GuestBrandedAccordion
                title={<div style={styles.header}>{bannerText.chooseConsentSettings}</div>}
                isOpen={isConsentSettingsOpen}
                onToggle={onClickOpenConsentSettings}
            >
                <SettingSection
                    heading={bannerText.necessaryHeader}
                    description={bannerText.necessaryDescription}
                    type={COOKIE_CATEGORY.NECESSARY}
                    value={consentSettings.necessary}
                    onChange={(e) => updateConsentSetting(COOKIE_CATEGORY.NECESSARY, e)}
                    styles={styles}
                />
                <SettingSection
                    heading={bannerText.performanceHeader}
                    description={bannerText.performanceDescription}
                    type={COOKIE_CATEGORY.PERFORMANCE}
                    value={consentSettings.performance}
                    onChange={(e) => updateConsentSetting(COOKIE_CATEGORY.PERFORMANCE, e)}
                    styles={styles}
                />
                <SettingSection
                    heading={bannerText.functionalityHeader}
                    description={bannerText.functionalityDescription}
                    type={COOKIE_CATEGORY.FUNCTIONALITY}
                    value={consentSettings.functionality}
                    onChange={(e) => updateConsentSetting(COOKIE_CATEGORY.FUNCTIONALITY, e)}
                    styles={styles}
                />
                <SettingSection
                    heading={bannerText.marketingHeader}
                    description={bannerText.marketingDescription}
                    type={COOKIE_CATEGORY.MARKETING}
                    value={consentSettings.marketing}
                    onChange={(e) => updateConsentSetting(COOKIE_CATEGORY.MARKETING, e)}
                    styles={styles}
                />
                <div style={styles.button}>
                    <GuestBrandedButton
                        appearance="lined"
                        text={bannerText.confirmSelectionButton}
                        onClick={onConfirmSelection}
                    />
                </div>
            </GuestBrandedAccordion>
        </div>
    );
};

CookieBannerConsentSettings.propTypes = {
    isConsentSettingsOpen: PropTypes.bool,
    onClickOpenConsentSettings: PropTypes.func,
    bannerText: PropTypes.object.isRequired,
    consentSettings: PropTypes.shape({
        necessary: PropTypes.bool,
        performance: PropTypes.bool,
        functionality: PropTypes.bool,
        marketing: PropTypes.bool,
    }),
    updateConsentSetting: PropTypes.func,
    onConfirmSelection: PropTypes.func,
};

CookieBannerConsentSettings.defaultProps = {
    isConsentSettingsOpen: false,
    onClickOpenConsentSettings: () => {},
    consentSettings: {
        necessary: true,
        performance: false,
        functionality: false,
        marketing: false,
    },
    updateConsentSetting: () => {},
    onConfirmSelection: () => {},
};

export default CookieBannerConsentSettings;
